import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icons/save-black.svg'


const _hoisted_1 = { class: "flex gap-4" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "bg-gray-100 border border-gray-300 py-2 px-4 rounded mb-4" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "flex gap-3 justify-end" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_9 = { class: "flex-1" }
const _hoisted_10 = { class: "border border-gray-200 shadow-md rounded-xl overflow-hidden bg-gray-100" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "bg-white p-4 text-gray-400 text-center" }, "Preview email", -1)
const _hoisted_12 = { class: "p-4 pb-0" }
const _hoisted_13 = { class: "bg-white px-8 py-4 pb-16" }
const _hoisted_14 = { class: "bg-gray-100 py-2 px-4 text-center" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 py-2 px-4 text-center h-10" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_input_label = _resolveComponent("input-label")!
  const _component_editor = _resolveComponent("editor")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FontAwesomeIcon, {
          class: "text-gray-400 mr-2",
          icon: "circle-info"
        }),
        _createTextVNode("Anda bisa mengatur pesan yang akan dikirimkan ke peserta asesmen ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_input_label, {
          label: "Header Email",
          isRequired: true
        }),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.header) = $event)),
          class: "p-2 border rounded w-full"
        }, null, 512), [
          [_vModelText, _ctx.header]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_input_label, {
          label: "Isi Email",
          isRequired: true
        }),
        _createVNode(_component_editor, {
          theme: "snow",
          content: _ctx.body,
          "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.body) = $event)),
          "content-type": "html"
        }, null, 8, ["content"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
          class: "p-2 rounded text-yellow-400 leading-6 text-sm font-semibold flex items-center gap-3"
        }, " Atur Ulang "),
        _createVNode(_component_router_link, {
          to: "/admin/home",
          class: "px-4 py-2 bg-transparent border-1 border-gray-300 rounded text-blue-900 text-sm leading-6 font-semibold flex items-center gap-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Batal ")
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          disabled: !_ctx.canSubmit,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveEmail && _ctx.saveEmail(...args))),
          class: _normalizeClass(["px-4 py-2 rounded text-black leading-6 text-sm font-semibold flex items-center gap-3", 
            _ctx.canSubmit ? 'bg-yellow-400 opacity-1' : 'bg-gray-400 opacity-30'
          ])
        }, [
          _hoisted_8,
          _createTextVNode(" Simpan ")
        ], 10, _hoisted_7)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.header || "HEADER"), 1),
            _createElementVNode("div", {
              innerHTML: _ctx.body,
              class: "py-4 no-style"
            }, null, 8, _hoisted_15),
            _hoisted_16
          ])
        ])
      ])
    ])
  ]))
}